module.exports = __webpack_public_path__ + "static/media/facebook@3x.eb12d558.png";